














































































































































































































































































import { Component, Watch, namespace, mixins } from 'nuxt-property-decorator'
import { Route } from 'vue-router'
import LazyHydrate from 'vue-lazy-hydration'
import { NuxtAppOptions } from '@nuxt/types'
import { CATALOG_API } from '~/assets/config/api-path'
import { IStyle } from '~/assets/interfaces/classes'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { IMeta } from '~/assets/interfaces/meta'
import { IBanner } from '~/assets/interfaces/banners'
import { IProductsRaw } from '~/assets/interfaces/products'
import { componentNameProducts } from '~/assets/functions/products'
import { declension } from '~/assets/functions/declension'
import MixinGeneral from '~/assets/mixins/general'
import { filterUrl } from '~/assets/filters/url'
import {
  ICatalogCategoryItem,
  ICatalogFilterItem,
} from '~/assets/interfaces/catalog'
import ComponentPageContent from '~/components/pages/content.vue'

const pageStore = namespace('page')
const siteStore = namespace('site')
const catalogStore = namespace('catalog')

interface IPopularSearch {
  title: string
  url: string
}

interface IPopularSearchRaw {
  title: string
  items: IPopularSearch[]
}

interface ISectionRaw {
  items: ICatalogCategoryItem[]
}

@Component({
  // watchQuery: true,
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentAlert: () => import('~/components/alerts/alert.vue'),
    ComponentNavigationBreadcrumbs: () =>
      import('~/components/navigation/breadcrumbs.vue'),
    ComponentTypographyH1: () => import('~/components/typography/h1.vue'),
    ComponentPageContent,
    ComponentSeoFilters: () =>
      import('~/components/navigation/seo-filters.vue'),
    ComponentCatalogSorting: () => import('~/components/catalog/sorting.vue'),
    ComponentProductItem1: () =>
      import('~/components/products/product-item-1.vue'),
    ComponentHeaderWithLink: () =>
      import('~/components/header/header-with-link.vue'),
    ComponentIntersect: () => import('~/components/intersect/intersect.vue'),
    ComponentProductItem3: () =>
      import('~/components/products/product-item-3.vue'),
    ComponentMobileProductItem3: () =>
      import('~/components/mobile/products/m-product-item-3.vue'),
    ComponentNavigationPagination: () =>
      import('~/components/navigation/pagination.vue'),
    ComponentBannerStandard: () =>
      import('~/components/banners/banner-standard.vue'),
    ComponentLoadingDots: () => import('~/components/loading/dots.vue'),
    ComponentCategoryPath: () =>
      import('~/components/navigation/category-path.vue'),
    ComponentMobileCategoryPath: () =>
      import('~/components/mobile/navigation/m-category-path.vue'),
    ComponentCatalogFilter: () =>
      import('~/components/catalog/filter/catalog-filter.vue'),
    ComponentMobileCatalogFilter: () =>
      import('~/components/mobile/catalog/filter/m-catalog-filter.vue'),
    ComponentFormButton: () => import('~/components/form/button.vue'),
    ComponentCatalogFilterReset: () =>
      import('~/components/catalog/filter/catalog-filter-reset.vue'),
    ComponentCatalogFilterType2: () =>
      import('~/components/catalog/filter/catalog-filter-type-2.vue'),
    ComponentCategoryPathDropDown: () =>
      import('~/components/navigation/category-path-drop-down.vue'),
    ComponentProductAdditionalWrapper: () =>
      import('~/components/products/product-additional-wrapper.vue'),
    ComponentCatalogCategoryItem: () =>
      import('~/components/catalog/category/category-item.vue'),
    LazyHydrate,
  },
  filters: {
    filterAmountProducts(num: number, amount: [string, string, string]) {
      return num.toString() + ' ' + declension(num, amount)
    },
  },
})
export default class pageCatalogSection extends mixins(MixinGeneral) {
  private async asyncData({
    $axios,
    route,
    error,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
    error: any
  }) {
    try {
      const response = await $axios.$get(
        filterUrl(CATALOG_API + '/' + route.params._slug),
        {
          params: route.query,
        }
      )

      return response
    } catch (err: any) {
      const statusCode =
        err && err.response && err.response.status
          ? (err.response.status as number)
          : 400
      switch (statusCode) {
        case 400:
          error({ statusCode: 400, message: 'Bad Request' })
          break
        case 403:
          error({ statusCode: 403, message: 'Forbidden' })
          break
        case 404:
          error({ statusCode: 404, message: 'Post not found' })
          break
        case 500:
          error({ statusCode: 500, message: 'Internal Server Error' })
          break
        case 502:
          error({ statusCode: 502, message: 'Bad Gateway' })
          break
        default:
          error({ statusCode: 400, message: 'Bad Request' })
          break
      }
    }
  }

  @siteStore.Getter('getFixedHeaderHeight')
  readonly getFixedHeaderHeight!: number

  @siteStore.Getter('getOptionsCatalogPageType')
  readonly getOptionsCatalogPageType!: string

  @catalogStore.State('backFromProductName')
  readonly backFromProductName!: string | null

  @catalogStore.State('catalogUrlBeforeLeave')
  readonly catalogUrlBeforeLeave!: string | null

  @catalogStore.Getter('getProducts')
  readonly getProducts!: IProductsRaw | null

  @catalogStore.Mutation('setBackFromProductName')
  private setBackFromProductName!: (val: string | null) => void

  @catalogStore.Mutation('setBackFromCatalogName')
  private setBackFromCatalogName!: (val: string | null) => void

  @catalogStore.Mutation('setCatalogUrlBeforeLeave')
  private setCatalogUrlBeforeLeave!: (val: string | null) => void

  @catalogStore.Mutation('setProducts')
  private catalogSetProduct!: (val: IProductsRaw | null) => void

  private productForScroll: string | null = null

  private get getOffset(): number {
    let offset = -32
    if (this.isMobile) {
      offset = -16
    }

    return offset
  }

  @Watch('backFromProductName', { immediate: true })
  private backFromProductNameHandler(value: string | null) {
    if (
      value &&
      this.products &&
      this.catalogUrlBeforeLeave === this.$route.fullPath
    ) {
      if (this.getProducts) {
        this.products = this.getProducts
      }
    }
  }

  private beforeRouteLeave(to: Route, from: Route, next: any) {
    if (to.name === 'products-_id') {
      this.catalogSetProduct(this.products)
      this.setBackFromProductName(to.params._id)
      this.setBackFromCatalogName(from.params._slug)
      this.setCatalogUrlBeforeLeave(from.fullPath)
    } else {
      this.catalogSetProduct(null)
      this.setBackFromProductName(null)
      this.setBackFromCatalogName(null)
      this.setCatalogUrlBeforeLeave(null)
    }

    next()
  }

  private beforeRouteUpdate(_to: Route, _: Route, next: any) {
    this.setBackFromProductName(null)
    this.setBackFromCatalogName(null)
    this.setCatalogUrlBeforeLeave(null)
    this.catalogSetProduct(null)

    next()
  }

  private async getContent(concat: boolean = false) {
    const response = await this.$axios.$get(
      filterUrl(CATALOG_API + '/' + this.$route.params._slug),
      {
        params: this.$route.query,
      }
    )

    this.meta = response.meta
    this.breadcrumbs = response.breadcrumbs || []
    this.pages = response.pages || 0
    this.amount = response.amount || 0
    this.seoFilters = response.seoFilters || []
    this.sections = response.sections || null
    this.categoryPath = response.categoryPath || null
    this.filter = response.filter || null
    this.banners = response.banners || []
    this.sorting = response.sorting || []
    if (this.products && concat) {
      this.products.items = this.products.items.concat(response.products.items)
    } else {
      this.products = response.products || null
    }
    this.productsAdditionalIds = response.productsAdditionalIds || []
    this.seo = response.seo || null
    this.popularSearches = response.popularSearches || null
  }

  private pages = 0
  private amount = 0
  private seoFilters = []
  private categoryPath = null
  private filter: ICatalogFilterItem[] | null = null
  private sorting = []
  private productsAdditionalIds: number[] = []
  private seo = null

  private styleGrid!: IStyle
  private isLoading = false

  private showOnlySections = false

  private get showProducts() {
    return (
      this.products && this.products.items && this.products.items.length > 0
    )
  }

  private popularSearches: IPopularSearchRaw | null = null

  @pageStore.Mutation('setBreadcrumbs') private setBreadcrumbs!: (
    breadcrumbs: IBreadcrumbsItem[]
  ) => void

  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  private meta: IMeta | null = null
  private breadcrumbs: IBreadcrumbsItem[] = []

  @Watch('meta', {
    immediate: true,
  })
  private metaHandler(val: IMeta) {
    if (val) {
      this.setMeta(val)
    }
  }

  @Watch('breadcrumbs', {
    immediate: true,
  })
  private breadcrumbsHandler(val: IBreadcrumbsItem[]) {
    if (val) {
      this.setBreadcrumbs(val)
    }
  }

  private banners: IBanner[] = []

  private get bannersRenderSidebar() {
    return this.banners.filter((banner) => banner.position === 'sidebar')
  }

  private get bannersRenderMainStart() {
    return this.banners.filter((banner) => banner.position === 'mainStart')
  }

  private routeFiltersIsEqual(to: Route, from: Route) {
    const filterKeys = this.filter ? this.filter.map((e) => e.key) : []
    const toFilters = Object.entries(to.query)
      .filter(([key]) => filterKeys.includes(key))
      .map(([key, value]) => {
        return {
          key,
          value,
        }
      })
    const fromFilters = Object.entries(from.query)
      .filter(([key]) => filterKeys.includes(key))
      .map(([key, value]) => {
        return {
          key,
          value,
        }
      })

    if (toFilters.length !== fromFilters.length) {
      return false
    }

    const difference = toFilters.filter((e) =>
      fromFilters.every(
        (i) => e.key !== i.key || (e.key === i.key && e.value !== i.value)
      )
    )

    return difference.length === 0
  }

  @Watch('$route')
  private async routeHandler() {
    if (this.$route.query.showMore !== '1') {
      this.isLoading = true
      await this.getContent()
      this.isLoading = false
    }
  }

  private styleSpacer!: IStyle

  private get classMbGutter() {
    return {
      [this.styleSpacer.mbGutter2]: !this.isMobile,
      [this.styleSpacer.mbGutter]: this.isMobile,
    }
  }

  private products: IProductsRaw | null = null
  private sections: ISectionRaw | null = null

  private get componentNameProducts() {
    return componentNameProducts(this.products, this.isMobile)
  }

  private get classProducts() {
    return {
      [this.$style.products]: true,
      [this.$style.table]: this.products
        ? this.products.type === 'table'
        : false,
      [this.$style.col6]: this.getOptionsCatalogPageType === 'type-2',
    }
  }

  private async showMore() {
    this.isLoading = true

    const query = { ...this.$route.query }
    const currentNum = Number(this.$route.query.page) || 1
    query.page = (currentNum + 1).toString()
    query.showMore = '1'
    await this.$router.replace({
      path: this.$route.path,
      query,
    })
    await this.getContent(true)

    this.isLoading = false
  }
}
